// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConfirmationRouteImport } from './routes/confirmation'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as CartRouteImport } from './routes/cart'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductSlugRouteImport } from './routes/product.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const OrdersRoute = OrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ConfirmationRoute = ConfirmationRouteImport.update({
            id: '/confirmation',path: '/confirmation',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CatalogRoute = CatalogRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CartRoute: CartRoute,CatalogRoute: CatalogRoute,CheckoutRoute: CheckoutRoute,ConfirmationRoute: ConfirmationRoute,LoginRoute: LoginRoute,OrdersRoute: OrdersRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SecurityRoute: SecurityRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,ProductSlugRoute: ProductSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)